import { helpers, required, requiredIf, email } from "@vuelidate/validators";
import { EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS, EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES } from "@/utils/constants.js";

/**
 * Full External Appeal validation
 * @param {object} appeal - the reactive form state
 */
export const externalAppealValidationRules = (appeal = {}) => {
    return {
        patient: {
            firstName: { required: helpers.withMessage('Patient First Name is required', required) },
            lastName: { required: helpers.withMessage('Patient Last Name is required', required) },
            dob: { required: helpers.withMessage('Patient Date of Birth is required', required) },
            email: { email: helpers.withMessage('Invalid email address', email) },
            phoneNumber: {}, // optional
            street: { required: helpers.withMessage('Street is required', required) },
            city: { required: helpers.withMessage('City is required', required) },
            state: { required: helpers.withMessage('State is required', required) },
            zipCode: { required: helpers.withMessage('Zip Code is required', required) },
            relationshipToPatient: { required: helpers.withMessage('Relationship to Patient is required', required) },
            otherRelationship: {
                required: helpers.withMessage(
                    'Relationship Description is required',
                    requiredIf(() => appeal.patient?.relationshipToPatient === EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS.Other)
                )
            }
        },

        authorizedRep: {
            fullName: {
                required: helpers.withMessage(
                    'Your Name is required',
                    requiredIf(() => appeal.patient?.relationshipToPatient !== EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS.Self)
                )
            },
            phoneNumber: {
                required: helpers.withMessage(
                    'Your Phone Number is required',
                    requiredIf(() => appeal.patient?.relationshipToPatient !== EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS.Self)
                )
            },
            email: { email: helpers.withMessage('Invalid email address', email) }
        },

        healthPlan: {
            healthInsuranceCompany: { required: helpers.withMessage('Health Insurance Company is required', required) },
            patientInsuranceId: { required: helpers.withMessage('Patient Insurance ID is required', required) },
            otherHmoName: {
                required: helpers.withMessage(
                    'Health Insurance Company Name is required',
                    requiredIf(() => appeal.healthPlan?.healthInsuranceCompany === EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES.Other)
                )
            },
            otherTypeOfCoverage: {
                required: helpers.withMessage(
                    'Type of Coverage Name is required',
                    requiredIf(() => appeal.healthPlan?.typeOfCoverage === EXTERNAL_APPEALS_HEALTH_INSURANCE_COMPANIES.Other)
                )
            }
        },

        provider: {
            name: { required: helpers.withMessage('Provider Name is required', requiredIf(() => appeal.isExpedited)) },
            street: { required: helpers.withMessage('Provider Street is required', requiredIf(() => appeal.isExpedited)) },
            city: { required: helpers.withMessage('Provider City is required', requiredIf(() => appeal.isExpedited)) },
            state: { required: helpers.withMessage('Provider State is required', requiredIf(() => appeal.isExpedited)) },
            zipCode: { required: helpers.withMessage('Provider Zip Code is required', requiredIf(() => appeal.isExpedited)) },
            phoneNumber: { required: helpers.withMessage('Provider Phone Number is required', requiredIf(() => appeal.isExpedited)) },
            email: { email: helpers.withMessage('Invalid email address', email) },
            representative: {}
        },

        summaryOfAppeal: { required: helpers.withMessage('Summary of Appeal is required', required) },
        internalAppealStatus: { required: helpers.withMessage('Internal Appeal Status is required', required) },
        isForwardingAuthorized: { required: helpers.withMessage('Forwarding Authorization answer is required', required) },
        signature: { required: helpers.withMessage('Signature is required', required) },
        signatureRelationship: {
            required: helpers.withMessage(
                'Signature Relationship is required',
                requiredIf(() => appeal.patient?.relationshipToPatient !== EXTERNAL_APPEALS_PATIENT_RELATIONSHIPS.Self)
            )
        }
    };
};
